import { Routes } from '@angular/router';
import { authenticatedRouteGuards, canActivateProjects } from '@shared/guard/guard';
import { PageKey } from '@shared/services/page/models/page.key';

export const reportsRoute: Routes = [
  {
    path: 'reports/projects',
    loadComponent: () => import('./pages/projects-dashboard/projects-dashboard.component').then(m => m.ProjectsDashboardComponent),
    canActivate: [...authenticatedRouteGuards, canActivateProjects],
    data: {
      title: 'Dashboard de projetos',
      key: PageKey.REPORTS_PROJECTS
    }
  }
];
